<template>
    <!-- eslint-disable vue/no-v-html -->
    <div v-html="highlightText" />
</template>

<script>
export default {
  name: 'HighlightText',

  props: {
    keywords: {
      type: String,
      default: '',
    },
    text: {
      type: [String, Number],
      default: '',
    },
  },

  computed: {
    highlightText() {
      if (!this.keywords) {
        return `<span>${this.text}</span>`;
      }
      // const keywords = this.keywords.replace(/([+?*.^${}\\/\-\\|\[\]()])/g, '\\$1');
      const keywordsReg = new RegExp(`(${this.keywords})`, 'ig');

      if (typeof this.text === 'number') {
        /* eslint-disable vue/no-side-effects-in-computed-properties,no-new-wrappers */
        this.text = new String(this.text);
      }
      const text = this.text.replace(keywordsReg, '<i class="hightlight-text">$1</i>');

      return `<span>${text}</span>`;
    },
  },
};
</script>

<style lang="less">
@green-color: #00cc26;

.hightlight-text {
    font-style: normal;
    color: @green-color;
}
</style>
